import React from 'react';
import { PureBreadcrumbsItem } from '@base/lib/PureBreadcrumbs';
import BreadcrumbSchema from '@base/common/BreadcrumbSchema';
import { ISpuInfo, IVariant } from 'base/interfaces/product';

type ProdBreadcrumbSchemaProps = {
    spuInfo: ISpuInfo;
    variant: IVariant;
};

const ProdBreadcrumbSchema: React.FC<ProdBreadcrumbSchemaProps> = ({spuInfo, variant }) => {
    const list: PureBreadcrumbsItem[] = [];
    const categoryInfo = variant?.categoryInfo
    const variantName = variant?.name

    if (categoryInfo) {
        list.push({
            name: categoryInfo.catName,
            url: categoryInfo.catLinkUrl,
        });
    }
    if (variantName) {
        list.push({
            name: variantName,
        });
    }
    return list.length ? <BreadcrumbSchema id={spuInfo.id} items={list} /> : null;
};

export default ProdBreadcrumbSchema;
